'use strict';
function syncTransferTableVisibility() {
    var $table = $('#transfer_create_table');
    var $divButtons = $('#div_buttons');

    var rowCount = $table.find('tbody tr').length;

    if (rowCount > 0) {
        $table.show();
        $divButtons.show();
    } else {
        $table.hide();
        $divButtons.hide();
    }
}

var tableTarget = document.getElementById('transfer_create_table');

if (tableTarget) {
    var observer = new MutationObserver(function() {
        syncTransferTableVisibility();
    });

    observer.observe(tableTarget, {
        childList: true,
        subtree: true
    });
}


$(document).ready(function() {
    syncTransferTableVisibility();
});


(function(z, _) {


    /**
     * Material grid
     */
    z.TransferMaterialGrid = z.GridView.extend({

        /**
         * Url for the generating transfer
         */
        GENERATE_TRANSFER_URL: '/api/materialtransfer/addNew',
        UPDATE_TRANSFER_URL: '/api/materialtransfer/update',
        UPDATE_MATERIALS_TRANSFER_URL: '/api/materialtransfer/updateMaterials',

        /**
         * Bounding element
         */
        el: "#page-wrapper",

        /**
         * Events
         *
         * @return {undefined}
         */
        events: function() {
            return _.extend({}, z.FiltersView.prototype.events,{
                "click #add-materialtransfers-modal-btn": "openNewTransferWindow",
                "click #transfer_material_form_showStock": "showStocks",
                "change #transfer_material_form_type": "toggleTransferFields",
                // "click .material-edit-button": "onEditEntry",
                "click #transfer_material_form_importMaterials": "onImportEntry",
                "click #transfer_material_form_scanMaterials": "onScanEntry",
                "click #transfer-material-scan-save-button": "addScanEntry",
                "keypress #scan-pnMaterial-field": "onScan",
                "click #transfer-material-import-close-button": "closeImportSection",
                "click #transfer-material-scan-close-button": "closeScanSection",
                "click #transfer_material_form_saveToWarehouse": "sendItemsToTransfer",
                "click #transfer_material_form_savePrepared": "updateToExecutionTransfer",
                // "click #transfer_material_form_saveGiven": "updateToPreparedTransfer",
                "click #transfer_material_form_cancelTransfer": "updateToCancelTransfer",
                "click #transfer_material_form_saveFinalized": "updateToFinalizedTransfer",
                "click #transfer_material_form_saveFinalizedFirst": "updateToFinalizedTransferFirst",
                "click #transfer_material_form_bonConsum": "updateBonConsumTransfer",
                "click #transfer_material_form_generatePV": "generatePV",
                "click #materialfilters-showFinalStatusRequests-field": "_onFinalStatusChange",
                "click #materialfilters-showCanceledStatusRequests-field": "_onCancelStatusChange",
                "click #transfer_material_add_materials": "_onAddMaterials",
                "click #transfer_material_delete_materials": "deletePendingMaterials"
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {
            z.GridView.prototype.initialize.apply(this, arguments);

            this.finalStatus = ['3', '5'];
            this.canceled = '4';

            this.initializeEvents();
        },

        /**
         * Initialize the events.
         *
         * @return {undefined}
         */
        initializeEvents: function() {

            this.$(".chosen-select").chosen({
                search_contains: true
            });

            this.toggleTransferFields();
            this.syncTableVisibility();
        },

        /**
         * Get datatable id.
         *
         * @return {string} - datatable id
         */
        getDatatableId: function() {
            return 'page-material_transfer-datatable';
        },

        /**
         * Get page path.
         *
         * @return {string} - page path
         */
        getPath: function() {
            return 'materialtransfer';
        },

        /**
         * Get success message container id.
         * This function will be overridden by every view that will extend the GridView.
         *
         * @return {string} - success message container id
         */
        getSuccessMessageContainerId: function() {
            return 'transfer-success-message';
        },
        onImportEntry: function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.$("#import-transferMaterials-panel").show();
        },
        onScanEntry: function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.$("#scan-transferMaterials-panel").show();
            // this.$("#scan-pnMaterial-field").focus();
        },

        closeImportSection: function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.$("#import-transferMaterials-panel").hide();
        },
        closeScanSection: function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.$("#scan-transferMaterials-panel").hide();
        },

        /**
         * Hide the success message
         * @return {undefined}
         * @private
         */
        _hideExtraSuccess: function(){

            var $error = this.$('#transfer-success-message');

            $error
                .finish()
                .fadeOut(0)
                .addClass('hidden');
        },

        /**
         * Display the error message
         * @param {string} message The message to be displayed
         * @return {undefined}
         * @private
         */
        _showExtraError: function(message){

            this._hideExtraSuccess();

            var $error = this.$('#transfer-error-message');

            $error
                .text(message)
                .removeClass('hidden')
                .fadeOut(0)
                .fadeIn('slow')
                .delay(5000)
                .fadeOut('slow', function(){

                    $error.addClass('hidden');
                });
        },

        deletePendingMaterials: function() {
            var $tbody = $('#add-to-transfer-materials-container');
            var $table = $('#add_to_transfer_table');

            $tbody.empty();
            $table.hide();
        },

        hasPendingMaterials: function() {
            var $tbody = $('#add-to-transfer-materials-container');

            var visibleRows = $tbody.find('tr').filter(function() {
                return $(this).css('display') !== 'none';
            });

            return visibleRows.length > 0;
        },

        syncTableVisibility: function() {
            var $tbody = $('#add-to-transfer-materials-container');
            var $table = $('#add_to_transfer_table');
            var $tableAddButton = $('#transfer_material_add_materials');
            var $tableDeleteButton = $('#transfer_material_delete_materials');

            var visibleRows = $tbody.find('tr').filter(function() {
                return $(this).css('display') !== 'none';
            });

            if (visibleRows.length > 0) {
                $table.show();
                $tableAddButton.show();
                $tableAddButton.css('margin-right',"5px");
                $tableDeleteButton.show();
            } else {
                $table.hide();
                $tableAddButton.hide();
                $tableDeleteButton.hide();
            }
        },

        toggleTransferFields: function () {

            const type = parseInt(this.$('#transfer_material_form_type').val(), 10);

            this.$('#technician-field').closest('.col-lg-3').toggle(type === 4);
            this.$('#division-field').closest('.col-lg-3').toggle(type === 5);
            this.$('#transfer_material_form_saveFinalizedFirst').closest('.col-lg-12').toggle(type === 3);
            this.$('#transfer_material_form_bonConsum').closest('.col-lg-12').toggle(type === 5);
            this.$('#transfer_material_form_saveToWarehouse').closest('.col-lg-12').toggle([1,2,4].includes(type));
            this.$('#project-field').closest('.col-lg-3').toggle([1,2,3,5].includes(type));
        },
        // onImportEntry: function (e) {
        //     e.stopPropagation();
        //     this.$("#import-transferMaterials-panel").show();
        // },
        //
        // closeImportSection: function (e) {
        //     e.stopPropagation();
        //     this.$("#import-transferMaterials-panel").hide();
        // },

        /**
         * Redirects to download page.
         * @return {undefined}
         * @private
         */
        _downloadTemplate: function(){

            // var record = this._getFormTemplateRecord();

            // this.model.set(record);
            //
            // if (!this.model.isValid(true)) {
            //
            //     return;
            // }

            var url = this._getMaterialTemplateOriginDownloadUrl();

            window.open(url);
        },
        /**
         * Retrieves the form record.
         * @return {object} The form record
         * @private
         */
        _getFormTemplateRecord: function(){

            return {
                type: this.$('#material-import-type-field').val()
            };
        },

        /**
         * Returns the url from where you can download the template.
         * @returns {string} The url
         * @private
         */
        openNewTransferWindow: function(){
            window.open('/transfer-note/new', '_blank');
        },

        /**
         * Hide the error message
         * @return {undefined}
         * @private
         */
        _hideExtraError: function(){

            var $error = this.$('#transfer-error-message');

            $error
                .finish()
                .fadeOut(0)
                .addClass('hidden');
        },

        /**
         * Display the success message
         * @param {string} message The message to be displayed
         * @return {undefined}
         * @private
         */
        _showExtraSuccess: function(message){

            this._hideExtraError();

            var $success = this.$('#transfer-success-message');

            $success
                .html(message)
                .removeClass('hidden')
                .fadeOut(0)
                .fadeIn('slow')
                .delay(5000)
                .fadeOut('slow', function(){

                    $success.addClass('hidden');
                });
        },

        /**
         * Get success message text.
         * This function will be overridden by every view that will extend the GridView.
         *
         * @return {string} - success message text variable
         */
        getSuccessMessageText: function() {
            return Translator.trans('js.success_message_material_form');
        },

        /**
         * Method that shows loader spinner button.
         *
         * @param {Object} loading - should show or hide the mask
         * @param {string} buttonSelector - button selector
         * @private
         * @return {undefined}
         */
        _isLoading: function(loading, buttonSelector) {

            loading = loading ? loading : _.isUndefined(loading);

            var $submitBtn   = this.$(buttonSelector);
            var $formFields  = this.$('fieldset');
            var ladda =  $submitBtn.data('ladda') ?  $submitBtn.data('ladda') :  $submitBtn.ladda().data('ladda');

            if( loading ){
                ladda.start();
                $formFields.attr('disabled', true);
            } else {
                ladda.stop();
                $formFields.removeAttr('disabled');
            }
        },

        /**
         * Loading animation for generate invoice btn
         * @param {bool} loading Should show or hide the animation
         * @returns {undefined}
         * @private
         */
        _isLoadingGenerateTransferBtn: function(loading, btn) {

            var $BtnEl = btn;
            this._isLoading(loading, $BtnEl);

        },
        /**
         * Get success event name
         *
         * @return {string} - success event name
         */
        getSuccessEventName: function() {
            return 'material.success';
        },

        showFieldsValidationsAlert:function () {
            var transferType = document.getElementById("transfer_material_form_type").value;
            var idProject = document.getElementById("transfer_material_form_idProject").value;
            var technician = document.getElementById("transfer_material_form_technician").value;
            var division = document.getElementById("transfer_material_form_division").value;

            // VALIDARI
            if (!transferType) {
                alert("Selecteaza tipul de transfer.");
                return;
            }

            if (transferType == 4 && !technician) {
                alert("Selecteaza tehnicianul.");
                return;
            }

            if (transferType == 5 && !division) {
                alert("Selecteaza Divizia Marketplace.");
                return;
            }

            if ((transferType == 1 || transferType == 2 || transferType == 3 || transferType == 5) && !idProject) {
                alert("Introdu ID-ul de proiect.");
                return;
            }
        },

        showStocks: function (e) {
            e.preventDefault();

            var transferType = this.$("#transfer_material_form_type").val();
            var idProject = this.$("#transfer_material_form_idProject").val();
            var technician = this.$("#transfer_material_form_technician").val();
            var division = this.$("#transfer_material_form_division").val();

            // VALIDARI
            if (!transferType) {
                alert("Selecteaza tipul de transfer.");
                return;
            }

            if (transferType == 4 && !technician) {
                alert("Selecteaza tehnicianul.");
                return;
            }

            if (transferType == 5 && !division) {
                alert("Selecteaza Divizia Marketplace.");
                return;
            }

            if ((transferType == 1 || transferType == 2 || transferType == 3 || transferType == 5) && !idProject) {
                alert("Introdu ID-ul de proiect.");
                return;
            }

            const payload = {
                I_PLANT: '1000',
                transferType: transferType
            };

            if (transferType == 4) {
                payload.technician = technician;
            }
            else if (transferType == 5)
            {
                payload.division = division;
                payload.idProject = idProject;

            } else {
                payload.idProject = idProject;
            }

            // console.log(transferType);
            // console.log(idProject);
            // console.log(division);

            fetch('/api/materialtransfer/stocks', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({payload})
            })
                .then(response => {

                    if (!response.ok) {
                        // console.log(response)
                        return response.json().then(err => {
                            throw new Error(err.errors || 'Eroare server');
                        });
                    }

                    return response.blob();
                })
                .then(blob => {

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;

                    // nume fisier
                    a.download = 'stocks_export.csv';

                    document.body.appendChild(a);
                    a.click();

                    a.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch(error => {
                    alert(error.message);
                });
        },


        insertItems: function () {
            var data = [];

            var transferType = $("#transfer_material_form_type").val();
            var idProject = $("#transfer_material_form_idProject").val();
            var technician = $("#transfer_material_form_technician").val();
            var division = $("#transfer_material_form_division").val();

            // var globalItems = {invoiceNumber:invoiceNumber, totalNotTva:total_not_tva, invoiceType:invoiceType, orderId:order.id};
            var globalItems = { transferType:transferType, idProject:idProject, technician:technician, division:division};

            data.push({ globalItems: globalItems });


            // $('#add_to_transfer_table tbody tr').each(function() {
            $('#transfer_create_table tbody tr').each(function() {
                var row = $(this);
                var rowData = {
                    pn: row.find('td').eq(0).text(),
                    name: row.find('td').eq(1).text(),
                    warehouse: row.find('td').eq(3).text(),
                    quantity: row.find('td').eq(4).text(),
                    aquisitionPrice: row.find('td').eq(5).text(),
                    supplier: row.find('td').eq(6).text(),
                    batch: row.find('td').eq(7).text(),
                    partida: row.find('td').eq(8).text(),
                    status: row.find('td').eq(9).text(),
                    modified: row.attr('data-modified') || '0'
                };
                data.push(rowData);
            });

            if (transferType == '')
            {
                // Stop the loading for the preview invoice button

                return false;
            }
            // console.log(data);
            // this._isLoadingGenerateExtraInvoiceBtn(true);
            return data;
        },

        addNewItems: function () {
            var data = [];
            var transferId = $("#transfer_id-field").text();

            var globalItems = { transferId:transferId, transferStatus:status};

            data.push({ globalItems: globalItems });

            $('#add_to_transfer_table tbody tr').each(function() {
                // $('#transfer_create_table tbody tr').each(function() {
                var row = $(this);
                var rowData = {
                    pn: row.find('td').eq(0).text(),
                    name: row.find('td').eq(1).text(),
                    warehouse: row.find('td').eq(3).text(),
                    quantity: row.find('td').eq(4).text(),
                    aquisitionPrice: row.find('td').eq(5).text(),
                    supplier: row.find('td').eq(6).text(),
                    batch: row.find('td').eq(7).text(),
                    partida: row.find('td').eq(8).text(),
                    status: row.find('td').eq(9).text(),
                    modified: row.attr('data-modified') || '0'
                };
                data.push(rowData);
            });

            // console.log(data);

            return data;

        },

        /**
         * Get generating insert
         * @returns {string}
         * @private
         */
        sendItemsToTransfer: function() {
            this.showFieldsValidationsAlert();
            if (this.hasPendingMaterials()) {
                this._showExtraError('Aveti materiale in tabelul de adaugat. Adaugati-le la nota de transfer sau renuntati la ele inainte de a continua.');
                return false;
            }
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_saveToWarehouse'));
            var transferItems = this.insertItems();

            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveToWarehouse'));
                this.$("#transfer_material_form_saveToWarehouse").removeClass('disabled');
                return false;
            }
            var url = this.GENERATE_TRANSFER_URL;

            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {
                    // location.reload();
                    this.$("#transfer_material_form_saveToWarehouse").addClass('disabled');
                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        const id = response.data;

                        if (!id) {
                            alert('Nu s-a putut obține ID-ul transferului');
                            return;
                        }

                        window.location.href = '/materialtransfer/' + id;
                        // location.reload();
                    },3000);
                },
                error: (xhr, status, error) => {
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveToWarehouse'));
                    this.$("#transfer_material_form_saveToWarehouse").removeClass('disabled');
                    this._showExtraError(xhr.responseText);
                }
            });
        },

        /**
         * Get generating insert
         * @returns {string}
         * @private
         */
        updateToFinalizedTransferFirst: function() {
            if (this.hasPendingMaterials()) {
                this._showExtraError('Aveti materiale in tabelul de adaugat. Adaugati-le la nota de transfer sau renuntati la ele inainte de a continua.');
                return false;
            }
            var transferItems = this.insertItems();
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_saveToWarehouse'));
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_saveFinalizedFirst'));
            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveToWarehouse'));
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveFinalizedFirst'));
                this.$("#transfer_material_form_saveToWarehouse").removeClass('disabled');
                this.$("#transfer_material_form_saveFinalizedFirst").removeClass('disabled');
                return false;
            }
            var url = this.GENERATE_TRANSFER_URL;

            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {
                    // location.reload();
                    this.$("#transfer_material_form_saveToWarehouse").addClass('disabled');
                    this.$("#transfer_material_form_saveFinalizedFirst").addClass('disabled');
                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        const id = response.data;

                        if (!id) {
                            alert('Nu s-a putut obține ID-ul transferului');
                            return;
                        }

                        window.location.href = '/materialtransfer/' + id;
                        // location.reload();
                    },3000);
                },
                error: (xhr, status, error) => {
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveToWarehouse'));
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveFinalizedFirst'));
                    this.$("#transfer_material_form_saveToWarehouse").removeClass('disabled');
                    this.$("#transfer_material_form_saveFinalizedFirst").removeClass('disabled');
                    this._showExtraError(xhr.responseText);
                }
            });
        },



        collectDataToUpdate: function (status) {
            var data = [];
            var transferId = $("#transfer_id-field").text();

            var globalItems = { transferId:transferId, transferStatus:status};

            data.push({ globalItems: globalItems });

            $('#transfer_create_table tbody tr').each(function() {
                var row = $(this);
                var rowData = {
                    pn: row.find('td').eq(0).text(),
                    name: row.find('td').eq(1).text(),
                    warehouse: row.find('td').eq(3).text(),
                    quantity: row.find('td').eq(4).text(),
                    aquisitionPrice: row.find('td').eq(5).text(),
                    supplier: row.find('td').eq(6).text(),
                    batch: row.find('td').eq(7).text(),
                    partida: row.find('td').eq(8).text(),
                    status: row.find('td').eq(9).text(),
                    modified: row.attr('data-modified') || '0'
                };
                data.push(rowData);
            });

            // console.log(data);

            return data;


        },

        updateToExecutionTransfer: function() {
            if (this.hasPendingMaterials()) {
                this._showExtraError('Aveti materiale in tabelul de adaugat. Adaugati-le la nota de transfer sau renuntati la ele inainte de a continua.');
                return false;
            }
            var transferItems = [];
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_savePrepared'));
            var transferItems = this.collectDataToUpdate(2);

            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_savePrepared'));
                this.$("#transfer_material_form_saveForLater").removeClass('disabled');
                return false;
            }
            var url = this.UPDATE_TRANSFER_URL;



            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {

                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        location.reload();
                    },2000);
                },
                error: (xhr, status, error) => {
                    // this._isLoadingGenerateExtraInvoiceBtn(false);
                    this.$("#transfer_material_form_saveGiven").removeClass('disabled');
                    this._showExtraError(xhr.responseText);
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_savePrepared'));
                }
            });
        },

        updateToPreparedTransfer: function() {
            var transferItems = [];
            var transferId = $("#transfer_id-field").text();
            var globalItems = { transferId:transferId, transferStatus: 3};
            transferItems.push({ globalItems:globalItems });
            transferItems.push(this.collectDataToUpdate());

            if (!transferItems)
            {
                this.$("#transfer_material_form_saveForLater").removeClass('disabled');
                return false;
            }
            var url = this.UPDATE_TRANSFER_URL;



            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {
                    // location.reload();
                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        location.reload();
                    },2000);
                },
                error: (xhr, status, error) => {
                    this._showExtraError(xhr.responseText);
                }
            });
        },

        updateToCancelTransfer: function() {

            if (this.hasPendingMaterials()) {
                this._showExtraError('Aveti materiale in tabelul de adaugat. Adaugati-le la nota de transfer sau renuntati la ele inainte de a continua.');
                return false;
            }
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_cancelTransfer'));
            var transferItems = this.collectDataToUpdate(4);

            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_cancelTransfer'));
                this.$("#transfer_material_form_saveForLater").removeClass('disabled');
                return false;
            }
            var url = this.UPDATE_TRANSFER_URL;
            if (confirm('Sigur doriti sa anulati acest transfer?')) {
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: {transferData: transferItems},
                    success: (response) => {
                        this._showExtraSuccess('Datele au fost salvate cu succes!')
                        setTimeout(function () {
                            location.reload();
                        }, 2000);
                    },
                    error: (xhr, status, error) => {
                        this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_cancelTransfer'));
                        this.$("#transfer_material_form_saveGiven").removeClass('disabled');
                        this._showExtraError(xhr.responseText);
                    }
                });
            }
        },

        updateToFinalizedTransfer: function() {
            if (this.hasPendingMaterials()) {
                this._showExtraError('Aveti materiale in tabelul de adaugat. Adaugati-le la nota de transfer sau renuntati la ele inainte de a continua.');
                return false;
            }
            var transferItems = [];
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_saveFinalized'));
            var transferItems = this.collectDataToUpdate(3);

            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveFinalized'));
                this.$("#transfer_material_form_saveForLater").removeClass('disabled');
                return false;
            }
            var url = this.UPDATE_TRANSFER_URL;



            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {
                    // location.reload();
                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        location.reload();
                    },2000);
                },
                error: (xhr, status, error) => {
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_saveFinalized'));
                    this._showExtraError(xhr.responseText);
                }
            });
        },

        updateBonConsumTransfer: function() {
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_form_bonConsum'));
            var transferItems = this.insertItems();

            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_bonConsum'));
                this.$("#transfer_material_form_saveForLater").removeClass('disabled');
                return false;
            }
            var url = this.GENERATE_TRANSFER_URL;

            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {
                    // location.reload();
                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        const id = response.data;

                        if (!id) {
                            alert('Nu s-a putut obține ID-ul transferului');
                            return;
                        }

                        window.location.href = '/materialtransfer/' + id;
                        // location.reload();
                    },3000);
                },
                error: (xhr, status, error) => {
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_form_bonConsum'));
                    this.$("#transfer_material_form_saveToWarehouse").removeClass('disabled');
                    this._showExtraError(xhr.responseText);
                }
            });
        },

        _onAddMaterials: function() {
            this._isLoadingGenerateTransferBtn(true, $('#transfer_material_add_materials'));
            var transferItems = this.addNewItems();

            if (!transferItems)
            {
                this._isLoadingGenerateTransferBtn(false, $('#transfer_material_add_materials'));
                this.$("#transfer_material_add_materials").removeClass('disabled');
                return false;
            }
            var url = this.UPDATE_MATERIALS_TRANSFER_URL;

            $.ajax({
                url: url,
                method: 'POST',
                data: { transferData: transferItems },
                success: (response) => {
                    // location.reload();
                    this._showExtraSuccess('Datele au fost salvate cu succes!')
                    setTimeout(function () {
                        const id = response.data;

                        if (!id) {
                            alert('Nu s-a putut obține ID-ul transferului');
                            return;
                        }

                        window.location.href = '/materialtransfer/' + id;
                        // location.reload();
                    },3000);
                },
                error: (xhr, status, error) => {
                    this._isLoadingGenerateTransferBtn(false, $('#transfer_material_add_materials'));
                    this.$("#transfer_material_add_materials").removeClass('disabled');
                    this._showExtraError(xhr.responseText);
                }
            });
        },

        _onFinalStatusChange: function (e) {
            if (e.currentTarget.checked === true) {
                this._updateChosenField('materialfilters-status-field', this.finalStatus);
            }
        },
        _onCancelStatusChange: function (e) {
            if (e.currentTarget.checked === true) {
                this._updateChosenField('materialfilters-status-field', this.canceled);
            }
        },

        _updateChosenField: function (id, value) {
            this.$('#' + id).val(value);
            this.$('#' + id).trigger("chosen:updated");
        },


        generatePV: function () {
            var transferId = $("#transfer_id-field").text();

            var url = '/materialtransfer/' + transferId + '/preview';

            window.open(url, '_blank');
        },

        getIndividualTransferPath: function(id) {
            return this.getPath() + '/' + id;
        },

        /**
         * Display a link to the individual order
         * @param {mixed} data - datatable param
         * @return {string} - the two names concatenated
         */
        displayLinkToIndividualTransfer: function(data) {

            return '<a href="' + this.getIndividualTransferPath(data) + '" class="transferLink">' + data + '</a>';
        },

        onScan: function(e) {
            if (e.which === 13 || e.key === 'Enter') {
                e.preventDefault();

                var $field = $(e.currentTarget);
                var $caption = $('#transfer_create_scan_table caption');
                var pnValue = $field.val().trim();

                if (!pnValue) return;

                this.processScan(pnValue, $caption);

                // $field.val('').focus();
            }
        },

        processScan: function(pn, $caption) {
            var transferId = this.$("#transfer_id-field").text() || '';
            // Citire transferType - incearca val() (input) si text() (span/td)
            var transferType = this.$("#transfer_inttype-field").val()
                || this.$("#transfer_inttype-field").text()
                || this.$("#transfer_material_form_type").val()
                || '';
            transferType = String(transferType).trim();

            var technicianOrProject = this.$('#transfer_projectId_technician-field').val()
                || this.$('#transfer_projectId_technician-field').text()
                || this.$('#transfer_material_form_idProject').val()
                || this.$('#transfer_material_form_technician').val()
                || '';
            technicianOrProject = String(technicianOrProject).trim();

            const payload = {
                I_PLANT: '1000',
                transferType: transferType || '',
                transferId: transferId || '',
                pnMaterial: pn
            };

            if (transferType == 4) {
                payload.technician = technicianOrProject;
            } else if (transferType == 5) {
                // payload.division = division;
                payload.idProject = technicianOrProject;
            } else {
                payload.idProject = technicianOrProject;
            }

            $caption.css('color', 'black').text('Se cauta PN: ' + pn + '...');

            fetch('/api/materialtransfer/scanStocks', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ payload })
            })
                .then(response => response.json())
                .then(data => {
                    if (!data.success) {
                        console.log();
                        if (data.notDefined)
                        {
                            $caption.css('color', 'red').text('✘ ' + data.notDefined);
                            return;
                        }
                        $caption.css('color', 'red').text('✘ ' + 'Nu exista stoc pentru PN: ' + pn);
                        return;
                    }

                    $.each(data.stocks, function(i, stock) {
                        // console.log(stock);
                        var row = '<tr>' +
                            '<td style="width: auto">' + stock.pn + '</td>' +
                            '<td style="width: auto">' + stock.name + '</td>' +
                            '<td style="width: auto">' + stock.location + '</td>' +
                            '<td style="width: auto">' + stock.warehouse + '</td>' +
                            '<td style="width: auto">' + stock.quantity + '</td>' +
                            '<td style="text-align: center; width: auto;"><input type="number" width: auto; min="0" max="'+stock.quantity+'"></td>' +
                            '<td style="width: auto">' + stock.price + '</td>' +
                            '<td style="display: none">' + stock.supplier + '</td>' +
                            '<td style="display: none">' + stock.batch + '</td>' +
                            '<td style="width: auto">' + stock.partida + '</td>' +
                            '</tr>';

                        $('#scan-transfer-materials-container').append(row);
                    });

                    if (data.stocks.length > 0)
                    {

                        $caption.css('color', 'green')
                            .text('✔ ' + data.stocks.length + ' rezultate gasite pentru PN: ' + pn);
                    }
                    else
                    {

                        $caption.css('color', 'red')
                            .text('✘ Nu s-au gasit rezultate pentru PN: ' + pn);
                    }

                })
                .catch(function(error) {

                    $caption.css('color', 'red').text('✘ Eroare: ' + error.message);
                });
        },



        addScanEntry: function(e) {
            e.preventDefault();

            var rowsAdded = 0;
            let container = document.querySelector('#to-transfer-materials-container');
            let containerTr = '#to-transfer-materials-container';

            if (
                $('#transfer_id-field').length > 0 &&
                (
                    $('#transfer_type-field').text() !== "Transfer marfa rezervata la sediu catre santier" ||
                    $('#transfer_status-field').text() !== "De pregatit"
                )
            ) {
                containerTr = '#add-to-transfer-materials-container';
                container = document.querySelector('#add-to-transfer-materials-container');
            }

            // ========== FAZA 1: VALIDARE COMPLETĂ - colectează TOATE erorile ==========
            let scanErrors = [];

            $('#scan-transfer-materials-container tr').each(function() {
                var $row = $(this);
                var cantitateDorita = parseFloat($row.find('input[type="number"]').val()) || 0;

                if (!cantitateDorita || cantitateDorita <= 0) {
                    return; // skip
                }

                var tds = $row.find('td');
                var pn = $(tds[0]).text().trim();
                var gestiune = $(tds[3]).text().trim();
                // ========== FIX: parseFloat pe cantitateStoc ==========
                var cantitateStoc = parseFloat($(tds[4]).text().trim()) || 0;

                // Verificare cantitate cerută vs stoc disponibil din SAP
                if (cantitateDorita > cantitateStoc) {
                    scanErrors.push('✘ PN: ' + pn + ' - cantitatea ceruta (' + cantitateDorita + ') depaseste stocul disponibil (' + cantitateStoc + ')');
                    return;
                }

                // Verificare dacă există deja în tabelul destinație
                var existingPnRow = null;
                $(containerTr + ' tr').each(function() {
                    var $r = $(this);
                    if ($r.find('td').eq(0).text().trim() === pn && $r.find('td').eq(3).text().trim() === gestiune) {
                        existingPnRow = $r;
                        return false;
                    }
                });

                if (existingPnRow) {
                    var currentQty = parseFloat(existingPnRow.find('td').eq(4).text()) || 0;
                    var qt = currentQty + cantitateDorita;

                    // ========== FIX: data-max cu fallback pe cantitateStoc din SAP ==========
                    var maxQty = parseFloat(existingPnRow.attr('data-max')) || cantitateStoc;

                    if (qt > maxQty) {
                        scanErrors.push('✘ PN: ' + pn + ' - cantitatea totala (' + qt + ') depaseste stocul maxim disponibil (' + maxQty + ')');
                    }
                }
            });

            // Dacă există erori, afișează-le pe toate și oprește
            if (scanErrors.length > 0) {
                $('#transfer_create_scan_table caption')
                    .css('color', 'red')
                    .html(scanErrors.join('<br>'));
                return;
            }

            // ========== FAZA 2: TOTUL OK - adaugă rândurile ==========
            $('#scan-transfer-materials-container tr').each(function() {
                var $row = $(this);
                var $cantitateDorita = $row.find('input[type="number"]');
                var cantitateDorita = $cantitateDorita.val();

                if (!cantitateDorita || parseInt(cantitateDorita) <= 0) {
                    return; // skip
                }

                var tds = $row.find('td');
                var pn        = $(tds[0]).text().trim();
                var denumire  = $(tds[1]).text().trim();
                var locatie   = $(tds[2]).text().trim();
                var gestiune  = $(tds[3]).text().trim();
                var cantitateStoc = $(tds[4]).text().trim();
                var pret      = $(tds[6]).text().trim();
                var supplier  = $(tds[7]).text().trim();
                var batch     = $(tds[8]).text().trim();
                var partida   = $(tds[9]).text().trim();

                var existingPnRow = null;
                $(containerTr + ' tr').each(function() {
                    var $r = $(this);
                    if ($r.find('td').eq(0).text().trim() === pn && $r.find('td').eq(3).text().trim() === gestiune) {
                        existingPnRow = $r;
                        return false;
                    }
                });

                if (existingPnRow) {
                    var currentQty = parseFloat(existingPnRow.find('td').eq(4).text()) || 0;
                    var qt = currentQty + parseFloat(cantitateDorita);
                    existingPnRow.find('td').eq(4).text(qt);
                    existingPnRow.attr('data-modified', '1');
                    // ========== FIX: setează data-max dacă nu există deja ==========
                    if (!existingPnRow.attr('data-max')) {
                        existingPnRow.attr('data-max', cantitateStoc);
                    }
                    existingPnRow.find('td').eq(9).text(1);
                    existingPnRow.find('tr').css('display', 'table-row');
                } else {
                    var newRow =
                        '<tr data-modified="1" data-max="' + cantitateStoc + '">' +
                        '<td>' + pn + '</td>' +
                        '<td>' + denumire + '</td>' +
                        '<td>' + locatie + '</td>' +
                        '<td>' + gestiune + '</td>' +
                        '<td>' + cantitateDorita + '</td>' +
                        '<td>' + pret + '</td>' +
                        '<td>' + supplier + '</td>' +
                        '<td>' + batch + '</td>' +
                        '<td>' + partida + '</td>' +
                        '<td class="itemStatus" style="display: none">1</td>' +
                        '<td class="text-center">' +
                        '<a onclick="deleteRow(this)" class="btn btn-danger btn-xs delete-param">' +
                        '<i class="fa fa-trash"></i></a>' +
                        '</td>' +
                        '</tr>';
                    container.insertAdjacentHTML('beforeend', newRow);
                }

                rowsAdded++;
            });

            if (rowsAdded > 0) {
                $('#transfer_create_scan_table caption')
                    .css('color', 'green')
                    .text('✔ ' + rowsAdded + ' materiale adăugate în nota de transfer.');

                this.$("#scan-pnMaterial-field").val('').focus();
                $('#scan-transfer-materials-container').empty();
                this.syncTableVisibility();

                if (typeof manageDeleteButtons === 'function') {
                    manageDeleteButtons();
                }
            } else {
                $('#transfer_create_scan_table caption')
                    .css('color', 'red')
                    .text('✘ Completează cantitatea dorită pentru cel puțin un material.');
            }
        },

        manageDeleteButtons: function () {
        const $tbody = $('#to-transfer-materials-container');
        const $visibleRows = $tbody.find('tr').filter(function() {
            return $(this).css('display') !== 'none';
        });

        const countRows = $visibleRows.length;

        if (countRows === 1) {
            // Un singur rând rămas - ascunde butonul de delete
            $visibleRows.find('.delete-param').hide();
        } else {
            // Mai multe rânduri - arată butoanele de delete pe toate
            $tbody.find('.delete-param').show();
        }
    }

    });

})(window.z = window.z || {}, _);
